import { Box, Radio, RadioGroup, Stack, Text } from "@chakra-ui/react";
import { useQuery } from "react-query";
import { getRequests } from "../../../services/adminApi";
import Spinner from "../../../shared/components/Spinner";

const ReadingRequestSelector = ({ onSelect, requestId }) => {
  const { data, isLoading } = useQuery("requests", () => {
    return getRequests();
  });

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Box>
      <RadioGroup
        value={requestId}
        onChange={(value) => {
          onSelect(parseInt(value));
        }}
      >
        <Stack spacing="4">
          {data.data.map((req) => (
            <Box key={req.id} bg="gray.800" mb="1" p="3">
              <Radio value={req.id} isChecked={req.id === requestId}>
                <Text fontSize="0.8em">
                  <strong>Request # {req.id}: </strong>
                  {req.description}
                  <br />
                  <Text color="gray.400">Submitted on {req.submittedAt}</Text>
                </Text>
              </Radio>
            </Box>
          ))}
        </Stack>
      </RadioGroup>
    </Box>
  );
};

export default ReadingRequestSelector;
